(function() {
  var settings = window.theme && theme.settings ? theme.settings : {};
  if (settings.cartAddShadowTelemetry !== true) return;

  var STORAGE_KEY = 'um_cart_add_shadow_telemetry_v1';
  var MAX_EVENTS = 80;

  function shouldDebugLog() {
    try {
      return /(?:\?|&)um_shadow_debug=1(?:&|$)/.test(window.location.search);
    } catch (_) {
      return false;
    }
  }

  function safeNowIso() {
    try {
      return new Date().toISOString();
    } catch (_) {
      return '';
    }
  }

  function toTextBody(body) {
    if (body == null) return '';
    if (typeof body === 'string') return body;
    if (body instanceof URLSearchParams) return body.toString();
    if (body instanceof FormData) {
      var pairs = [];
      body.forEach(function(value, key) {
        pairs.push(String(key) + '=' + String(value));
      });
      return pairs.join('&');
    }
    try {
      return JSON.stringify(body);
    } catch (_) {
      return '[unserializable-body]';
    }
  }

  function summarizeBody(rawBody) {
    var body = String(rawBody || '');
    var out = {
      bodyType: '',
      itemIds: [],
      addonHints: [],
      hasParentId: false,
      hasParentLineKey: false,
      hasConfigId: false
    };

    if (!body) return out;

    var trimmed = body.trim();
    if (trimmed.charAt(0) === '{' || trimmed.charAt(0) === '[') {
      out.bodyType = 'json';
      try {
        var parsed = JSON.parse(trimmed);
        var items = Array.isArray(parsed && parsed.items) ? parsed.items : (Array.isArray(parsed) ? parsed : []);
        items.forEach(function(item) {
          if (!item || typeof item !== 'object') return;
          if (item.id != null) out.itemIds.push(String(item.id));
          if (item.parent_id != null) out.hasParentId = true;
          if (item.parent_line_key != null) out.hasParentLineKey = true;
          var props = item.properties && typeof item.properties === 'object' ? item.properties : {};
          if (props._config_id) out.hasConfigId = true;
          if (props['Add-on']) out.addonHints.push(String(props['Add-on']));
        });
      } catch (_) {}
      return out;
    }

    out.bodyType = 'form';
    var idMatches = body.match(/(?:^|[?&])id=([^&]+)/g) || [];
    idMatches.forEach(function(match) {
      var value = match.split('=').slice(1).join('=');
      if (value) out.itemIds.push(decodeURIComponent(value));
    });
    out.hasParentId = /(?:^|[?&])parent_id=/.test(body);
    out.hasParentLineKey = /(?:^|[?&])parent_line_key=/.test(body);
    out.hasConfigId = /properties\[%5Fconfig%5Fid\]|properties\[_config_id\]/i.test(body);
    if (/add-?on|artist.?border|aged|personalisation|pop.?art|unique.?3d/i.test(body)) {
      out.addonHints.push('addon-keywords-present');
    }
    return out;
  }

  function appendEvent(event) {
    var payload = event || {};
    payload.ts = payload.ts || safeNowIso();

    window.__UM_CART_ADD_SHADOW__ = window.__UM_CART_ADD_SHADOW__ || { events: [] };
    var events = window.__UM_CART_ADD_SHADOW__.events;
    events.push(payload);
    if (events.length > MAX_EVENTS) events.splice(0, events.length - MAX_EVENTS);

    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(events));
    } catch (_) {}

    if (shouldDebugLog() && window.console && console.log) {
      console.log('[UM Cart Shadow]', payload);
    }
  }

  function captureStack() {
    try {
      throw new Error('shadow');
    } catch (err) {
      var stack = String((err && err.stack) || '');
      if (!stack) return '';
      return stack.split('\n').slice(2, 8).join('\n');
    }
  }

  function isCartAddUrl(url) {
    return /\/cart\/add(?:\.js)?(?:[?#]|$)/.test(String(url || ''));
  }

  // hydrate previous log for convenience
  try {
    var prev = JSON.parse(window.localStorage.getItem(STORAGE_KEY) || '[]');
    window.__UM_CART_ADD_SHADOW__ = { events: Array.isArray(prev) ? prev : [] };
  } catch (_) {
    window.__UM_CART_ADD_SHADOW__ = { events: [] };
  }

  var originalFetch = window.fetch;
  if (typeof originalFetch === 'function') {
    window.fetch = function(resource, config) {
      var url = typeof resource === 'string' ? resource : (resource && resource.url ? resource.url : '');
      var cfg = config || {};
      if (isCartAddUrl(url)) {
        var bodyText = toTextBody(cfg.body);
        appendEvent({
          transport: 'fetch',
          phase: 'request',
          method: String(cfg.method || 'GET').toUpperCase(),
          url: url,
          summary: summarizeBody(bodyText),
          bodyPreview: bodyText.slice(0, 700),
          stack: captureStack()
        });
      }

      return originalFetch.apply(this, arguments).then(function(response) {
        if (isCartAddUrl(url)) {
          appendEvent({
            transport: 'fetch',
            phase: 'response',
            url: url,
            status: response && typeof response.status === 'number' ? response.status : null,
            ok: !!(response && response.ok)
          });
        }
        return response;
      });
    };
  }

  // XHR telemetry catches jQuery $.post and legacy ajax writers.
  var originalOpen = XMLHttpRequest.prototype.open;
  var originalSend = XMLHttpRequest.prototype.send;

  XMLHttpRequest.prototype.open = function(method, url) {
    this.__umShadow = this.__umShadow || {};
    this.__umShadow.method = String(method || 'GET').toUpperCase();
    this.__umShadow.url = String(url || '');
    return originalOpen.apply(this, arguments);
  };

  XMLHttpRequest.prototype.send = function(body) {
    var meta = this.__umShadow || {};
    if (isCartAddUrl(meta.url)) {
      var bodyText = toTextBody(body);
      appendEvent({
        transport: 'xhr',
        phase: 'request',
        method: meta.method || 'GET',
        url: meta.url,
        summary: summarizeBody(bodyText),
        bodyPreview: bodyText.slice(0, 700),
        stack: captureStack()
      });

      this.addEventListener('loadend', function() {
        appendEvent({
          transport: 'xhr',
          phase: 'response',
          method: meta.method || 'GET',
          url: meta.url,
          status: typeof this.status === 'number' ? this.status : null,
          ok: this.status >= 200 && this.status < 300
        });
      });
    }

    return originalSend.apply(this, arguments);
  };

  appendEvent({
    transport: 'meta',
    phase: 'ready',
    note: 'Cart add shadow telemetry active'
  });
})();
